<template>
  <div class="orderpaycontain">
    <input type="file" v-show="false" @change="input2change" ref="fileName2" v-if="radio=='2'"/>
    <div class="ordernum">
      <div ><span class="examl">订单编号：{{orderDetails.orderNo}}</span></div>
    </div>
    <div class="orderbottom">
      <div class="ordercontent"><span class="examl">批次名称</span> <span class="examr">{{orderDetails.appraisalBatchName}}</span></div>
      <div class="ordercontent"><span class="examl">考试科目</span> <span class="examr">{{orderDetails.subject}}</span></div>
      <div class="ordercontent"><span class="examl">考试工种</span> <span class="examr">{{orderDetails.occupation}}</span></div>
      <div class="ordercontent"><span class="examl">考试等级</span> <span class="examr">{{orderDetails.examRank}}</span></div>
      <div class="ordercontent"><span class="examl">支付人数</span> <span class="examr" >{{orderDetails.signUpCount}}</span></div> 
    </div>
    <div id="box2">
      <span class="pay_method">选择付款方式</span>
      <van-radio-group class="pay_radio"  v-model="radio" direction="horizontal">
        <van-radio name="1">线上支付</van-radio>
        <van-radio name="2">银行卡转账</van-radio>
      </van-radio-group>
      <template v-if="radio==='2'">
        <div style="margin:10px 0">收款信息<span style="color:red;font-size:14px;margin-left:5px">*转账备注需写清楚付款用途及付款人数</span></div>
        <div class="pay_message">
          <span>收款单位名称：深圳企鹅网络科技有限公司</span>
          <span>收款单位账号：1425 0000 585</span>
          <span>开户银行名称：招商银行</span>
          <span>开户行：深圳南山支行</span>
          <span>转账备注：报考订单号LM20200711</span>
        </div>
        <p style="margin:5px 0">*请上传支付凭证<span style="font-size:12px;color:#797979;">（上传支付JPG、JPEG、PNG、PDF格式）</span></p>
        <div id="one" style="margin:10px 0">
          <file-box
            @bindup="payfile"
            headert="支付凭证"
            :mainup="payfileUrl"
            :fileName="payfileName"
          ></file-box>
        </div>
      </template>
    </div>
    <div class="footer">
    <!-- <div style="width:100%;height:25px;background-color: rgb(228,228,230);"></div> -->
      <div>应付：<span v-if="orderDetails.payAmount">￥{{orderDetails.payAmount}}</span></div>
      <van-button v-if="radio=='1'"  class="submit" type="primary" @click="doWexinPay()" color="red" size="normal">支付</van-button>
      <van-button v-if="radio=='2'"  class="submit" type="primary" @click="commit(id)" color="#097DD3" size="normal">提交</van-button>

    <!-- <div v-if="radio=='1'">
      <span>应付：</span><span style="color: red;padding-top: 5px;">￥</span><span style="color: red; font-size: 26px; ">{{this.examPrices}}</span>
    </div>
    
    <van-button v-if="radio=='2'"  class="submit" type="primary" @click="commit(id)" color="#097DD3" size="normal">提交</van-button> -->
    <!-- <button @click="pay(id)">提交</button> -->
    </div>
  </div>
</template>
 
<script>
import headerBox from '@/components/header.vue'
import fileBox from "@/components/filebox.vue";
import { showaddres } from '../../api/apitotal';
import { RadioGroup, Radio } from 'vant';
import { unipayPay } from '../../utils/wxjssdk'
export default {
  components:{
    headerBox,
    fileBox,
  },
  data(){
    return{
      examPrices:0,
      radio: '1',
      shownopay:false,
      examsex:localStorage.getItem("examSex"),
      examphone:localStorage.getItem("examPhone"),
      id: this.$route.params.orderId,
      payfileUrl:"",
      payfileName: "",
      orderDetails: {}
    } 
  },
  created: function() {
    this.fetchOrderDetails();
  },
  methods:{
    fetchOrderDetails: function() {
      const params = {
        id: this.id
      }
      this.$http.get('/registration/order/id', {params}).then(res => {
        if (res.data.success) {
          console.log(res.data.data)
          this.orderDetails = res.data.data
        }
      })

    },
    commit(id){
      var item = this.$route.query.ExamOrder;
      id = item.map(item => item.id).join(',');
      if(this.payfileName != ""){
      console.log(id+'id')
       
        this.$http.post('registration/updatejg?Id='+id+'&payType='+'银行卡转账').then(res=>{
            if(res.data.success&&res.status==200){
              this.$http.post('examFile/import/getJpg?Id='+id+'&payVoucher='+this.payfileUrl).then(dat=>{
                this.$router.push({ path: '/orderpaysuccee' })
              })
              this.$router.push({ path: '/orderpaysuccee' })
            }
        })
    }
          
//         }else{
//           alert("支付失败,请重新支付")
//         }
        
// })
    },
    doWexinPay: function() {
      // this.submitPaySuccess();
      unipayPay(this.$route.params.orderId, this.submitPaySuccess)
    },
    submitPaySuccess: function() {
      const params = {
        orderId: this.$route.params.orderId,
        payType: this.payType,
      }
      this.$http.post('trans/order/pay', params).then(res => {
        if (res.data.success) {
          this.$router.replace('/orderpaysuccee')
        }
      })
    },
    pay(){
      let params = {
        orderId: this.$route.params.orderId,
        channel: 'JSAPI'
      }
      this.$http.post('/trans/order/unifiedOrder',{ params }).then(res=>{
        if(res.data.success&&res.status==200){
          
        }
      })
      //  this.$router.push({ path: '/orderpaysuccee' })

    },
    input2change(event) {
      var formdata = new FormData();
 
      formdata.append("file", event.target.files[0]);
 
      this.$http.post(this.$server.upload, formdata).then(
        (res) => {
          if (res.status == 200) {
            this.payfileUrl = this.$server.qxyRes + res.data[0].path
            this.payfileName = res.data[0].fileName
          }
        }
      );
    },
    payfile() {
      this.status = 2;
      this.$refs.fileName2.click();
    },
  },
  
  mounted(){
  this.shownopay=Number(this.$route.query.lookbool)
  }
 
}
</script>
<style lang="less" scoped>
.orderpaycontain{
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 32px;
  background: rgb(228, 228, 230);
  width: 100%;
  height: 100vh;
  position: relative;
}
 #top {
 
  text-align: center;
 height: @headerh;
   box-sizing: border-box;
  padding-top: @headerpt;
  background-color:@backgroundcolor;
  padding-bottom: @headerpb;
}
.orderpaycontain .orderheader{
  text-align: center;
}
 
.orderpaycontain .ordernum{
    position: relative;
    background: white;
    border-bottom: 1px solid #edebeb;
}
.orderpaycontain .ordernum_ing{
  position: absolute;
  right: @paddingpay;
  top: 0;
  color: rgb(182, 179, 179);
}
 
 
.orderpaycontain .orderbottom{
  background: white;
  border: 1px 0 1px 0 solid wheat
}
.orderpaycontain .orderbottom .ordercontent .examl{
color: rgb(182, 179, 179);
width: 160px;
font-size: 28px;
}
.orderpaycontain .orderbottom .ordercontent {
display: flex;
}
.orderpaycontain .orderbottom .ordercontent .examr{
color: black;
flex: 1;
padding: 0 0 20px 0;
}
.orderpaycontain .ordernum{
  height: 76px;
  line-height: 76px;
}
.orderpaycontain .ordernum,.orderpaycontain .orderbottom{
padding: 0 @paddingpay;
 
}
 
.orderbottom .ordercontent:nth-child(1){
  padding-top: @paddingpay;
}
#box2{
  margin-top: 30px;
  min-height: 94px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  background-color: white
}
#box2 .pay_method{
  font-weight: 600;
  margin:10px 0 20px 5px;
}
#box2 .pay_radio{
  margin-bottom: 10px;
}
#box2 .pay_message{
  background: #F4F4F4;
  padding: 10px;
  display: flex;
  flex-direction: column;
  font-size: 14PX;
}
#box2 .pay_message span{
  margin: 6px ;
}

.pay_next{
  padding-left: 30px;
  height: 300px;
}
.pay_next2{
  width: 670px;
  height: 300px;
  background-color: #F4F4F4;
  font-size: 28px;
  line-height: 55px;
  padding-left: 20px;
  padding-top: 20px;
}
.orderpaycontain .submit{
  float: right;
  margin-right: 16px;
  width: 200px;
  height: 100px;
}
.footer{
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  width: 100%;
  position: relative;
  bottom: 0;
}
</style>